export const BASE_URL = '/articles';
export const ROOT_CATEGORY_LINK = '/articles';
export const FILMS_CATEGORY_LINK = '/articles/films';
export const LATEST_ARTICLES_PAGE_SIZE = 3;
export const LATEST_FILMS_PAGE_SIZE = 6;
export const IMAGE_WIDTH_GRID_2 = 700;
export const IMAGE_WIDTH_GRID_3 = 455;
export const IMAGE_WIDTH_GRID_4 = 309;
export const FEATURED_SLIDE_IMAGE_WIDTH = 1920;
export const FEATURED_SLIDE_IMAGE_HEIGHT = 880;

export const DEFAULT_TITLE = 'archizeen';

export const PROPS_VARIABLES = {
    main: {
        size: 'large',
        variant: '01',
    },
    square: {
        size: 'medium',
        variant: '01',
    },
    portrait: {
        size: 'medium',
        variant: '02',
    },
    landscape: {
        size: 'medium',
        variant: '03',
    },
    films: {
        size: 'large',
        variant: '07',
    },
};
